module.exports = __webpack_public_path__ + "fa810eaa78fe5846a574a956d1662e9e.pdf";